import React, { useCallback, useMemo, useState } from 'react';
import { PackCard } from '../components/PackCard';
type Category = 'profesionales' | 'estudiantes';
interface Pack {
  title: string;
  description: string;
  packTitle: string;
  themeColor: 'blue' | 'green' | 'pink' | 'purple' | 'teal' | 'navy';
  imageSrc?: string;
  href: string;
  category: Category;
}
const packs: Pack[] = [{
  title: 'Nutrición',
  description: 'Sistema completo para nutricionistas: planes, recetas, seguimiento y educación alimentaria.',
  packTitle: 'NUTRICIÓN LISTA',
  themeColor: 'navy',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779676327/nutri-Photoroom_lqu1oy.png',
  href: 'https://nutripro.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Kinesiologia',
  description: 'Protocolos, sesiones y materiales listos para trabajar con pacientes.',
  packTitle: 'FONO PRO',
  themeColor: 'blue',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683333/hf_20260430_234428_41cb3c68-981e-4c20-8031-afe469b66fa3-Photoroom_t5d1cd.webp',
  href: 'https://kinesiologia.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Estimulacion Temprana',
  description: 'Material profesional organizado por edades, listo para usar en sesiones y consultorio.',
  packTitle: 'PSICO PRO',
  themeColor: 'green',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779678784/hf_20260505_021521_8449f97b-f5da-48cc-920a-25564eca795d-Photoroom_crk2ki.webp',
  href: 'https://estimulacion.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Nutricion',
  description: 'Guías, apuntes, actividades y recursos para cursar Nutrición con más orden.',
  packTitle: 'PSICOPEDAGÓGICO PRO',
  themeColor: 'purple',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683464/hf_20260505_030954_f3af6f54-07ee-4691-a63f-5e12ebacd2ee-Photoroom_yy1k1x.webp',
  href: 'https://carreranutri.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Kinesiologia',
  description: 'Materiales de estudio, guías prácticas y actividades para estudiantes de Kinesiología.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683311/hf_20260503_134623_1bb422cd-84e7-4ec9-9a58-4fe2f3159cdc-Photoroom_s9tico.webp',
  href: 'https://carrerakine.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Psicologia',
  description: 'Resúmenes, guías y materiales para organizar mejor la carrera de Psicología.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683525/hf_20260520_174347_12932f9a-1a74-4f23-8277-79ff39ba8c41-Photoroom_l0swcp.webp',
  href: 'https://carrerapsico.bibliotecaprofesional.com/',
  category: 'estudiantes'
}, {
  title: 'Medicina',
  description: 'Material de estudio para organizar mejor las materias más pesadas de Medicina.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal',
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779683538/hf_20260520_012628_b35a9d4b-1091-4884-813f-88053f218137-Photoroom_1_nwvifg.webp',
  href: 'https://medicina.bibliotecaprofesional.com/',
  category: 'estudiantes'
}];
export function ElegirPack() {
  const [selectedCategory, setSelectedCategory] = useState<Category>('profesionales');
  const filteredPacks = useMemo(() => packs.filter(pack => pack.category === selectedCategory), [selectedCategory]);
  const selectProfesionales = useCallback(() => setSelectedCategory('profesionales'), []);
  const selectEstudiantes = useCallback(() => setSelectedCategory('estudiantes'), []);
  return <main className="min-h-screen bg-[#F6F5F2] py-16 px-4 sm:px-6 lg:px-8 font-sans selection:bg-green-200 selection:text-green-900" data-id="element-40">
      <div className="max-w-[1400px] mx-auto" data-id="element-41">
        <header className="flex flex-col items-center text-center mb-16" data-id="element-42">
          <p className="mp-anim-fade-scale bg-[#E5F7EB] text-[#0A7D3B] text-xs font-bold px-4 py-1.5 rounded-full tracking-wider uppercase mb-6" data-id="element-43">
            Packs digitales para profesionales y estudiantes
          </p>

          <h1 className="mp-anim-fade-up text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#111111] tracking-tight mb-6" style={{
          animationDelay: '0.2s'
        }} data-id="element-44">
            ¿Qué tipo de material buscas?
          </h1>

          <p className="mp-anim-fade-up text-lg md:text-xl text-gray-500 max-w-2xl mx-auto mb-8" style={{
          animationDelay: '0.1s'
        }} data-id="element-45">
            Elegí tu pack y accedé a recursos listos para usar, imprimir y
            ahorrar horas de tu vida.
          </p>

          <nav aria-label="Filtrar por categoría" className="mp-anim-fade-up flex flex-wrap items-center justify-center gap-3" style={{
          animationDelay: '0.3s'
        }} data-id="element-46">
            <button type="button" onClick={selectProfesionales} aria-pressed={selectedCategory === 'profesionales'} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'profesionales' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-47">
              Profesionales
            </button>

            <button type="button" onClick={selectEstudiantes} aria-pressed={selectedCategory === 'estudiantes'} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'estudiantes' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-48">
              Estudiantes
            </button>
          </nav>
        </header>

        <section aria-label={`MegaPacks para ${selectedCategory}`} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center" data-id="element-49">
          {filteredPacks.map((pack, index) => <PackCard key={`${pack.category}-${pack.title}-${index}`} title={pack.title} description={pack.description} packTitle={pack.packTitle} themeColor={pack.themeColor} imageSrc={pack.imageSrc} href={pack.href} delay={0.3 + index * 0.08} priority={index < 3} data-id="element-50" />)}
        </section>
      </div>
    </main>;
}